<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary" style="vertical-align: middle">share</v-icon> {{ $t('canales.title') }}</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :widthModal="800"
        >
          <template slot="buttons">
            <!-- <v-tooltip bottom v-if="$store.state.permissions['entidades:create']">
              <v-btn
                @click="descargarTodo()"
                slot="activator"
                color="primary">
                <v-icon>sync</v-icon> Sincronizar
              </v-btn>
              <span>Sincronizar con el Portal Único de Trámites</span>
            </v-tooltip> -->
            <v-tooltip bottom v-if="$store.state.permissions['canales:create']">
              <v-btn color="primary"
                @click.native.stop="openModal()"
                slot="activator">
                <v-icon>add</v-icon> {{$t('common.add') }}
              </v-btn>
              <span>{{$t('canales.crud.agregarRegistro')}}</span>
            </v-tooltip>
          </template>

          <template slot="form">
            <v-card-title class="headline">
              <v-flex xs9>
                <v-icon>business</v-icon> {{ form.id ? $t('canales.crud.editarRegistro') :  $t('canales.crud.agregarRegistro') }}
              </v-flex>
              <v-flex xs2 text-md-right>
                <v-chip label color="success" text-color="white" v-if="form.estado == 'ACTIVO'">
                  {{ form.estado }}
                </v-chip>
                <v-chip label color="warning" text-color="white" v-if="form.estado == 'INACTIVO'">
                  {{ form.estado }}
                </v-chip>
              </v-flex>
              <v-flex xs1 text-md-right>
                <v-btn small flat icon @click.native="$store.commit('closeModal')">
                  <v-icon class="red--text">cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-form
              @submit.prevent="save"
              v-model="valid"
              ref="form"
              lazy-validation
              >
              <v-card-text>
                <v-container grid-list-md>
                  <v-tabs v-model="tab">
                    <v-tab href="#tab-1">Datos Generales</v-tab>
                    <v-tab href="#tab-2" v-if="form.clasificacion && form.clasificacion !== 'llamada'">Configuración {{form.clasificacion}}</v-tab>
                    <v-tab href="#tab-3" v-if="form.configuracion && form.configuracion.token">Token</v-tab>
                    <v-tab-item value="tab-1">
                      <v-card style="padding: 10px !important">
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-select
                                :label="$t('canales.crud.clasificacion')"
                                id="clasificacion"
                                v-model="form.clasificacion"
                                autofocus
                                :items="clasificaciones"
                                :rules="$validate(['required'])"
                                required
                              ></v-select>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                name="usuario"
                                :label="$t('canales.crud.usuario')"
                                id="usuario"
                                v-model="form.usuario"
                                maxlength="100"
                                v-if="form.clasificacion && form.clasificacion === 'llamada'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                name="mensaje_bienvenida"
                                :label="$t('canales.crud.mensaje_bienvenida')"
                                id="mensaje_bienvenida"
                                v-model="form.mensaje_bienvenida"
                                maxlength="1000"
                                counter
                              ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                              <v-combobox
                                :label="$t('puntos_atencion.titulo')"
                                chips
                                multiple
                                :items="puntosAtencion"
                                prepend-icon="share"
                                v-model="form.puntos_atencion"
                                item-text="identificador"
                                item-value="id"
                                :noDataText="$t('puntos_atencion.nodata')"
                              >
                                <template slot="selection" slot-scope="data">
                                  <v-chip
                                    close
                                    @input="removerPuntoAtencion(data.item)"
                                    :selected="data.selected"
                                  >
                                    {{data.item.identificador}}
                                  </v-chip>
                                </template>
                              </v-combobox>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item  value="tab-2" v-if="form.clasificacion && form.clasificacion !== 'llamada'">
                      <v-card style="padding: 10px !important">
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs6>
                              <v-text-field
                                name="usuario"
                                :label="$t('canales.crud.usuario')"
                                id="usuario"
                                v-model="form.usuario"
                                maxlength="100"
                                v-if="tieneUsuario(form.clasificacion)"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs6>
                              <v-text-field
                                name="clave"
                                label="Clave"
                                id="clave"
                                :append-icon="getIcon"
                                @click:append="changeIcon"
                                :type="hidePass ? 'password' : 'text'"
                                v-model="form.clave"
                                maxlength="30"
                                v-if="tieneClave(form.clasificacion)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs6>
                              <v-text-field
                                name="ruta_perfil"
                                :label="$t('canales.crud.ruta_perfil')"
                                prepend-icon="public"
                                id="ruta_perfil"
                                v-model="form.ruta_perfil"
                                maxlength="100"
                                v-if="esWhatsapp(form.clasificacion)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                              name="sesion_id"
                              :label="$t('canales.crud.sesion_id')"
                              prepend-icon="public"
                              id="sesion_id"
                              v-model="form.sesion_id"
                              maxlength="100"
                              v-if="esWhatsapp(form.clasificacion)"
                            ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field
                                name="ruta_perfil"
                                :label="$t('canales.crud.servidor')"
                                prepend-icon="email"
                                id="ruta_perfil"
                                v-model="form.ruta_perfil"
                                maxlength="100"
                                v-if="esCorreo(form.clasificacion)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field
                                name="ruta_perfil"
                                :label="$t('canales.crud.twitter_id')"
                                prepend-icon="public"
                                id="ruta_perfil"
                                v-model="form.ruta_perfil"
                                maxlength="100"
                                v-if="esTwitter(form.clasificacion)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout wrap>
                            <v-text-field
                              name="sesion_url"
                              :label="$t('canales.crud.sesion_url')"
                              prepend-icon="public"
                              id="sesion_url"
                              v-model="form.sesion_url"
                              maxlength="100"
                              v-if="esWhatsapp(form.clasificacion)"
                            ></v-text-field>
                          </v-layout>
                          <v-layout wrap>
                            <v-flex xs6>
                              <v-text-field
                                name="servidor_smtp"
                                :label="$t('canales.crud.servidor_smtp')"
                                prepend-icon="mail_outline"
                                id="servidor_smtp"
                                v-model="form.configuracion.servidor_smtp"
                                maxlength="100"
                                v-if="esCorreo(form.clasificacion)"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                name="puerto_smtp"
                                :label="$t('canales.crud.puerto_smtp')"
                                prepend-icon="swap_calls"
                                id="puerto_smtp"
                                v-model="form.configuracion.puerto_smtp"
                                maxlength="100"
                                v-if="esCorreo(form.clasificacion)"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item  value="tab-3" v-if="form.configuracion && form.configuracion.token">
                      <v-card style="padding: 10px !important">
                        <v-card-text>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-alert
                                color="info"
                                :value="true"
                                style="overflow: auto;">
                                <div class="text-xs-justify">
                                  Bearer {{form.configuracion.token}}
                                </div>
                              </v-alert>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-container>
                <log-datos :data="logDatos" v-if="logDatos"></log-datos>
              </v-card-text>
              <v-card-actions>
                <small class="error--text text-required">* {{$t('common.required_fields')}}</small>
                <v-spacer></v-spacer>
                <v-btn flat color="red"
                  @click.native="$store.commit('closeModal');">
                  <v-icon>close</v-icon> {{$t('common.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!valid">
                  <v-icon>check</v-icon> {{$t('common.save') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom v-if="$store.state.permissions['canales:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="editItem(items.item.id, 'system/canales', false)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="$store.state.permissions['canales:delete'] && $util.isRol('SUPERADMIN')">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="deleteItem(items.item.id, 'system/canales')">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
            <td>
              <v-tooltip bottom v-if="$store.state.permissions['canales:update']">
                <v-switch
                  v-model="items.item.active"
                  value="ACTIVE"
                  @change="changeActive(items.item, items.item.id, 'system/canales')"
                  hide-details
                  slot="activator"
                  color="success"></v-switch>
                <span>Activar/desactivar registro</span>
              </v-tooltip>
              <v-icon
                v-if="!$store.state.permissions['canales:update']"
                :color="items.item.active === 'ACTIVE' ? 'success' : 'error'">
                {{ items.item.active === 'ACTIVE' ? 'check' : 'close' }}
              </v-icon>
            </td>
            <td>{{ items.item.clasificacion }}</td>
            <td>{{ items.item.usuario }}</td>
            <td>
              <v-chip label color="success" text-color="white" v-if="items.item.estado == 'ACTIVO'">
                {{ items.item.estado }}
              </v-chip>
              <v-chip label color="warning" text-color="white" v-if="items.item.estado == 'INACTIVO'">
                {{ items.item.estado }}
              </v-chip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';
import token from '@/components/admin/modulo/mixins/token';
import LogDatos from '@/components/admin/usuario/LogDatos';
import logDatos from '@/components/admin/usuario/mixins/log-datos';

export default {
  mixins: [ crud, validate, token, logDatos ],
  created () {
    this.user = this.$storage.getUser();
    this.idEntidad = this.user.id_entidad;
  },
  mounted () {
    this.recuperarPuntosAtencion();
  },
  data () {
    return {
      tab: 'tab-1',
      logDatos: null,
      successAlert: false,
      graphql: false, // Definiendo el CRUD con Graphql
      url: 'system/canales',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('common.active'), sortable: false },
        { text: this.$t('canales.crud.clasificacion'), value: 'clasificacion' },
        { text: this.$t('canales.crud.usuario'), value: 'usuario' },
        { text: this.$t('common.status'), value: 'estado' }
      ],
      form: {
        clasificacion: '',
        usuario: '',
        clave: '',
        password: '',
        estado: '',
        configuracion: {},
        puntos_atencion: []
      },
      dataGraphql: `
        id
        clasificacion
        usuario
        clave
        estado
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      filters: [
        {
          field: 'clasificacion',
          label: this.$t('canales.crud.clasificacion'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'usuario',
          label: this.$t('canales.crud.usuario'),
          type: 'text',
          typeG: 'String'
        },
        {
          field: 'estado',
          label: this.$t('common.status'),
          type: 'select',
          typeG: 'EstadoEntidad',
          items: [
            { value: '', text: 'TODOS' },
            { value: 'ACTIVO', text: 'ACTIVO' },
            { value: 'INACTIVO', text: 'INACTIVO' }
          ]
        }
      ],
      clasificaciones: ['correo', 'llamada'],
      // clasificaciones: ['facebook', 'whatsapp', 'twitter', 'correo', 'llamada'],
      idEntidad: null,
      valid: true,
      hidePass: true,
      puntosAtencion: []
    };
  },
  methods: {
    recuperarPuntosAtencion () {
      this.puntosAtencion = [];
      this.$service.get(`system/puntos?estado=ACTIVO`, {})
      .then(response => {
        if (response) {
          response.rows.forEach((item) => {
            this.puntosAtencion.push({id: item.id, identificador: item.identificador});
          });
        }
      });
    },
    removerPuntoAtencion (item) {
      this.form.puntos_atencion.splice(this.form.puntos_atencion.indexOf(item), 1);
      this.form.puntos_atencion = [...this.form.puntos_atencion];
    },
    tieneUsuario (clasificacion) {
      return typeof clasificacion !== 'undefined' && ['twitter', 'whatsapp', 'facebook', 'correo', 'llamada'].indexOf(clasificacion) !== -1;
    },
    tieneClave (clasificacion) {
      return typeof clasificacion !== 'undefined' && ['twitter', 'facebook', 'correo'].indexOf(clasificacion) !== -1;
    },
    esTwitter (clasificacion) {
      return typeof clasificacion !== 'undefined' && clasificacion.indexOf('twitter') !== -1;
    },
    esCorreo (clasificacion) {
      return typeof clasificacion !== 'undefined' && clasificacion.indexOf('correo') !== -1;
    },
    esWhatsapp (clasificacion) {
      return typeof clasificacion !== 'undefined' && clasificacion.indexOf('whatsapp') !== -1;
    },
    openModal (data = {}, form = true) {
      this.valid = true;
      this.$refs.form.reset();
      this.logDatos = null;
      if (data.id) {
        this.$nextTick(() => {
          this.logDatos = this.getLogDatos(data);
          this.form = data;
          if (!this.form.configuracion) this.form.configuracion = {};
        });
      } else {
        this.form = {
          clasificacion: '',
          usuario: '',
          clave: '',
          estado: '',
          configuracion: {}
        };
      }
      if (form) {
        this.$store.commit('openModal');
      }
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        if (data.id) {
          let id = data.id;
          delete data.id;
          this.$service.put(`${this.url}/${id}`, data)
            .then(response => {
              if (response) {
                this.$message.success(`¡Datos Actualizados!`, null, { timeout: 2000 });
                this.$store.commit('closeModal');
                this.updateList();
              }
            });
        } else {
          data.estado = 'ACTIVO';
          this.$service.post(`${this.url}`, data)
          .then(response => {
            if (response) {
              if (response.message === 'Se ha creado el registro y la conexión fue insatisfactoria') {
                this.$message.error(`Los datos de conexión de la cuenta no son correctos `, null, { timeout: 5000 });
              }
              this.$message.success(`¡Registro Creado!`, null, { timeout: 2000 });
              this.$store.commit('closeModal');
              this.updateList();
            }
          });
        }
      }
    },
    descargarTodo () {
      // TODO: Implementar función de sincronización con el portál único
    },
    changeIcon () {
      if (this.form.clave.length) {
        this.hidePass = !this.hidePass;
      }
    }
  },
  watch: {
    'form.clave': function (val) {
      if (val && val.length === 0) {
        this.hidePass = true;
      }
    }
  },
  computed: {
    getIcon () {
      return this.form && this.form.clave && this.form.clave.length === 0 ? 'lock' : this.hidePass ? 'visibility' : 'visibility_off';
    }
  },
  components: {
    CrudTable,
    LogDatos
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/canales/Canales.vue